export default "__VITE_ASSET__BFsLXcdl__"